module.exports = __webpack_public_path__ + "static/media/mobile9.2f6f16e6.png";